import {Product} from '@/src/core/domain/entities/product'
import {BasketStoreInterface} from '@/src/presentation/stores/basket/basket.store.interface'
import {
  ProductListItemViewModel,
  ProductSimpleListItemViewModel,
  ProductWithVariantsListItemViewModel,
} from '@/src/presentation'
import {isSimpleProduct} from '@/src/entities/product/helpers'

export type ProductListItemViewModelFactory = (product: Product, basket?: BasketStoreInterface) => ProductListItemViewModel

export const productViewModelFactory: ProductListItemViewModelFactory = (product: Product, basket?: BasketStoreInterface) => {
  let productListViewModel: ProductListItemViewModel

  if (isSimpleProduct(product)) {
    productListViewModel = new ProductSimpleListItemViewModel(product, undefined, undefined, basket)
  } else {
    productListViewModel = new ProductWithVariantsListItemViewModel(product, undefined, undefined, basket)
  }

  return productListViewModel
}